import { MonitoringCriteriaItemModel } from '../../MonitorShared/model/monitoring-criteria-item.model';
import { JournodexSourceTypeEnum } from '../../../Monitor/Shared/enums/journodex-source-type.enum';

export class JournodexTypeModel extends MonitoringCriteriaItemModel {
    declare id: JournodexSourceTypeEnum;
    disableTextbox: boolean;

    /**
     * Class constructor
     *
     * @param id
     * @param name
     * @param disableText
     */
    constructor(
        id: JournodexSourceTypeEnum,
        name: string,
        disableText: boolean = false
    ) {
        super(name, id);

        this.disableTextbox = disableText;
    }
}
